<template>
  <div class="crud-standalone-listagem">
    <v-container fluid class="px-6 py-0">
      <ErrorAlert :errors="errors" />

      <v-dialog
        v-model="modalIntegracaoTotvs"
        :persistent="integracaoTotvsEmAndamento"
        max-width="560"
      >
        <v-card class="integracao-totvs-card">
          <v-card-title class="integracao-totvs-header">
            <div
              class="integracao-totvs-header__icon"
              :class="`integracao-totvs-header__icon--${corIntegracaoTotvs}`"
            >
              <v-progress-circular
                v-if="integracaoTotvsEmAndamento"
                indeterminate
                size="24"
                width="3"
                color="white"
              />
              <v-icon v-else color="white" size="24">
                {{ iconeIntegracaoTotvs }}
              </v-icon>
            </div>
            <div>
              <div class="integracao-totvs-header__eyebrow">
                NSR {{ integracaoTotvs.pedidoNsr || integracaoTotvs.pedidoId }}
              </div>
              <div class="integracao-totvs-header__title">
                {{ tituloIntegracaoTotvs }}
              </div>
            </div>
          </v-card-title>

          <v-card-text class="pt-2 pb-3">
            <div class="integracao-totvs-step">
              <div class="integracao-totvs-step__marker is-success">
                <v-icon color="white" size="18">mdi-check</v-icon>
              </div>
              <div>
                <div class="integracao-totvs-step__title">
                  Operação no Cajupe
                </div>
                <div class="integracao-totvs-step__text">
                  {{ integracaoTotvs.mensagemCajupe }}
                </div>
              </div>
            </div>

            <div class="integracao-totvs-connector" aria-hidden="true"></div>

            <div class="integracao-totvs-step">
              <div
                class="integracao-totvs-step__marker"
                :class="`is-${corIntegracaoTotvs}`"
              >
                <v-progress-circular
                  v-if="integracaoTotvsEmAndamento"
                  indeterminate
                  size="18"
                  width="2"
                  color="white"
                />
                <v-icon v-else color="white" size="18">
                  {{ iconeIntegracaoTotvs }}
                </v-icon>
              </div>
              <div class="flex-grow-1">
                <div
                  class="d-flex flex-wrap align-center justify-space-between"
                >
                  <div class="integracao-totvs-step__title">
                    Integração com a TOTVS
                  </div>
                  <v-chip
                    small
                    label
                    :color="corIntegracaoTotvs"
                    text-color="white"
                    class="mt-1"
                  >
                    {{ rotuloIntegracaoTotvs }}
                  </v-chip>
                </div>
                <div
                  class="integracao-totvs-step__text mt-1"
                  aria-live="polite"
                >
                  {{ mensagemIntegracaoTotvs }}
                </div>
                <v-progress-linear
                  v-if="integracaoTotvsEmAndamento"
                  indeterminate
                  color="primary"
                  height="5"
                  rounded
                  class="mt-3"
                />
                <div
                  v-if="integracaoTotvsRequisicaoAtiva"
                  class="text-caption text-secondary mt-2"
                >
                  Você pode fechar esta janela e continuar consultando o Cajupe.
                  Aguarde este retorno antes de iniciar outra integração com a
                  TOTVS.
                </div>
              </div>
            </div>

            <v-alert
              v-if="integracaoTotvsFalhou"
              type="warning"
              text
              dense
              class="mt-5 mb-0"
            >
              A alteração no Cajupe está salva e não será desfeita por essa
              falha na integração.
            </v-alert>
          </v-card-text>

          <v-card-actions class="px-6 pb-5 pt-2">
            <v-btn
              v-if="podeReprocessarIntegracaoTotvs"
              outlined
              color="primary"
              class="text-none font-weight-bold"
              :loading="reprocessandoIntegracaoTotvs"
              @click="reprocessarIntegracaoTotvs"
            >
              <v-icon left>mdi-refresh</v-icon>
              {{
                integracaoTotvsFalhou
                  ? "Tentar integração novamente"
                  : "Iniciar integração com a TOTVS"
              }}
            </v-btn>
            <v-spacer />
            <v-btn
              class="text-none font-weight-bold btn-primary bg-gradient-primary"
              @click="fecharIntegracaoTotvs"
            >
              {{
                integracaoTotvsEmAndamento
                  ? "Continuar usando o Cajupe"
                  : "Fechar"
              }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-snackbar
        v-model="notificacaoIntegracaoTotvs.visivel"
        :color="notificacaoIntegracaoTotvs.cor"
        :timeout="8000"
        bottom
        right
      >
        {{ notificacaoIntegracaoTotvs.mensagem }}
        <template #action="{ attrs }">
          <v-btn
            text
            v-bind="attrs"
            class="text-none font-weight-bold"
            @click="abrirIntegracaoTotvs"
          >
            Ver detalhes
          </v-btn>
        </template>
      </v-snackbar>

      <!-- Dialog exportar  -->
      <v-dialog
        transition="dialog-bottom-transition"
        max-width="400"
        v-model="modalExportar"
        :loading="loading"
        persistent
      >
        <v-card>
          <v-card-title class="d-flex">
            {{ $t("Exportar") }}
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col class="d-flex" cols="12" sm="12">
                <v-select
                  id="select_apuracao_por"
                  :items="[
                    { text: $t('Mes'), value: 'mes' },
                    { text: $t('Dia'), value: 'dia' },
                    { text: $t('Folha_pagamento'), value: 'folhaPagamento' },
                  ]"
                  v-model="opcaoApuracaoCsv"
                  :label="$t('Tipo_exportacao')"
                  outlined
                ></v-select>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions class="justify-end">
            <v-btn
              :loading="loading"
              height="39"
              class="
                font-weight-bold
                text-capitalize
                btn-ls btn-secondary
                bg-gradient-light
                py-3
                px-6
              "
              @click="modalExportar = false"
              >{{ $t("Cancelar") }}</v-btn
            >
            <v-btn
              class="
                ma-1
                font-weight-bold
                text-capitalize
                btn-primary
                bg-gradient-primary
                py-3
                px-6
                ms-3
              "
              height="39"
              :disabled="!opcaoApuracaoCsv"
              :loading="loading"
              text
              @click="createCSV()"
              id="btn-download-exporta-tabela"
              >{{ $t("Download") }}</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Modal Delete sucesso -->
      <div id="dialog">
        <v-dialog v-model="deletado" persistent max-width="350">
          <v-card>
            <v-card-title class="headline">
              {{ $t("deletado_sucesso") }}
            </v-card-title>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                class="
                  ma-1
                  font-weight-bold
                  text-none
                  btn-primary
                  bg-gradient-primary
                  py-3
                  px-6
                  ms-3
                "
                height="39"
                text
                @click="deletado = false"
              >
                {{ $t("Confirmar") }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </div>

      <!-- Modal confirmar delete -->
      <v-dialog
        v-model="confirmarDelete"
        persistent
        max-width="350"
        class="dialog-deletado"
      >
        <v-card>
          <v-card-title class="headline">{{
            $t("Confirma_exclusao?")
          }}</v-card-title>
          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
              class="
                font-weight-bold
                text-capitalize
                btn-ls btn-secondary
                bg-gradient-light
                py-3
                px-6
              "
              height="39"
              text
              @click="confirmarDelete = false"
            >
              {{ $t("nao") }}
            </v-btn>

            <v-btn
              class="
                ma-1
                font-weight-bold
                text-none
                btn-primary
                bg-gradient-primary
                py-3
                px-6
                ms-3
              "
              height="39"
              text
              @click="deleteRecurso"
            >
              {{ $t("Confirmar") }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Modal mensagens -->
      <v-dialog
        transition="dialog-bottom-transition"
        max-width="800"
        v-model="modalMensagens"
        :loading="loading"
        persistent
      >
        <v-card>
          <v-card-title class="d-flex">
            {{ $t("Mensagens") }} - NSR {{ recurso.nsr || recurso.id }} -
            {{ recurso.solicitante.nome }}
          </v-card-title>
          <v-card-text>
            <div class="modal">
              <div class="modal-content">
                <v-alert
                  v-if="!recurso.mensagens || !recurso.mensagens.length"
                  text
                  type="info"
                  class="mb-0"
                >
                  {{ $t("Nenhuma_mensagem_encontrada") }}
                </v-alert>
                <div
                  v-for="mensagem in recurso.mensagens"
                  :key="mensagem.id"
                  class="mensagem-item"
                  :class="{
                    solicitante:
                      mensagem.responsavel.id === recurso.solicitante.id,
                    naoSolicitante:
                      mensagem.responsavel.id !== recurso.solicitante.id,
                  }"
                >
                  <p class="text-caption mb-1">
                    {{ $t("Data") }}: {{ mensagem.data | dataParaLeitura }}
                  </p>
                  <p class="font-weight-bold mb-1">
                    {{ $t("Responsavel") }}: {{ mensagem.responsavel.nome }}
                  </p>
                  <p class="mb-0">{{ mensagem.texto }}</p>
                </div>
              </div>
            </div>
          </v-card-text>
          <v-card-actions class="justify-end">
            <v-btn
              :loading="loading"
              height="39"
              class="
                font-weight-bold
                text-capitalize
                btn-ls btn-secondary
                bg-gradient-light
                py-3
                px-6
              "
              @click="modalMensagens = false"
              >{{ $t("Fechar") }}</v-btn
            >
            <v-btn
              v-if="
                recurso.statusPedido !== 'CONCLUIDO' &&
                recurso.statusPedido !== 'CANCELADO'
              "
              :loading="loading"
              height="39"
              class="
                font-weight-bold
                text-capitalize
                btn-ls btn-secondary
                bg-gradient-light
                py-3
                px-6
              "
              @click="modalNovaMensagem = true"
              >{{ $t("Novo_cadastro") }}</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Modal nova mensagem -->
      <v-dialog
        transition="dialog-bottom-transition"
        max-width="700"
        v-model="modalNovaMensagem"
        :loading="loading"
        persistent
      >
        <v-card>
          <v-card-title class="d-flex">
            {{ $t("Nova_mensagem") }} - NSR {{ recurso.nsr || recurso.id }} -
            {{ recurso.solicitante.nome }}
          </v-card-title>
          <v-card-text>
            <div class="modal-content">
              <v-col cols="12" md="12">
                <v-textarea
                  id="nova-mensagem"
                  v-model="novaMensagem"
                  :label="$t('Nova_mensagem')"
                  :maxlength="maxCaracteres"
                  :counter="maxCaracteres"
                  auto-grow
                  rows="3"
                  class="
                    input-style
                    font-size-input
                    text-light-input
                    placeholder-light
                    input-icon
                  "
                  dense
                  flat
                  filled
                  solo
                ></v-textarea>
              </v-col>
            </div>
          </v-card-text>
          <v-card-actions class="justify-end">
            <v-btn
              :loading="loading"
              height="39"
              class="
                font-weight-bold
                text-capitalize
                btn-ls btn-secondary
                bg-gradient-light
                py-3
                px-6
              "
              @click="modalNovaMensagem = false"
              >{{ $t("Cancelar") }}</v-btn
            >
            <v-btn
              class="
                ma-1
                font-weight-bold
                text-capitalize
                btn-primary
                bg-gradient-primary
                py-3
                px-6
                ms-3
              "
              height="39"
              :disabled="!novaMensagem.trim()"
              :loading="loading"
              text
              @click="enviarMensagem()"
              id="btn-download-exporta-tabela"
              >{{ $t("Enviar") }}</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-row class="mt-8 crud-standalone-layout">
        <v-row class="crud-standalone-actions">
          <v-btn
            :loading="loading"
            :disabled="periodoInvalido"
            @click.stop="exportaCsv()"
            class="
              ma-1
              font-weight-bold
              text-none
              btn-primary
              bg-gradient-primary
              py-3
              px-6
              ms-3
            "
            height="39"
            id="btn-exportar-tabela"
            v-can="'ROLE_PedidoOrcamentoDespesa_Export'"
          >
            <v-icon left dark> mdi-file-export-outline </v-icon>
            {{ $t("Exportar") }}
          </v-btn>

          <slot name="upload"> </slot>
        </v-row>
        <v-col cols="12">
          <template>
            <div>
              <v-card class="card-shadow border-radius-xl">
                <div class="card-header-padding">
                  <div class="d-flex align-center justify-space-between mb-2">
                    <span class="font-weight-bold text-typo">
                      <v-icon small class="me-2">mdi-filter-variant</v-icon>
                      {{ $t("Filtros") }}
                    </span>
                    <span class="text-caption text-secondary">
                      {{ $t("Resultado") }}: {{ totalItems }}
                    </span>
                  </div>
                  <v-row dense align="end">
                    <v-col cols="12" sm="6" md="3">
                      <v-text-field
                        v-model="nome"
                        :label="$t('Solicitante')"
                        name="nome"
                        clearable
                        @keyup.enter.native="filtrar"
                        hide-details
                        class="
                          input-style
                          font-size-input
                          text-light-input
                          placeholder-light
                          input-icon
                        "
                        dense
                        flat
                        filled
                        solo
                      >
                      </v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="2" id="campo-dt-inicio">
                      <CampoData
                        :payload="filtros.inicio"
                        @date="filtros.inicio = $event"
                        label="Inicio_do_periodo"
                      />
                    </v-col>
                    <v-col cols="12" sm="6" md="2" id="campo-dt-encerramento">
                      <CampoData
                        :payload="filtros.encerramento"
                        @date="filtros.encerramento = $event"
                        label="Final_do_periodo"
                      />
                    </v-col>
                    <v-col cols="12" sm="6" md="3">
                      <v-select
                        v-model="statusPedido"
                        :items="[
                          { value: 'PENDENTE', text: $t('PENDENTE') },
                          { value: 'APROVADO', text: $t('APROVADO') },
                          {
                            value: 'PROCESSAMENTO',
                            text: $t('PROCESSAMENTO'),
                          },
                          {
                            value: 'TRANSFERENCIARECURSO',
                            text: $t('TRANSFERENCIARECURSO'),
                          },
                          { value: 'ENCERRADO', text: $t('ENCERRADO') },
                          { value: 'CONCLUIDO', text: $t('CONCLUIDO') },
                          { value: 'CANCELADO', text: $t('CANCELADO') },
                        ]"
                        item-text="text"
                        item-value="value"
                        :label="$t('Status')"
                        clearable
                        hide-details
                        class="
                          input-style
                          font-size-input
                          text-light-input
                          placeholder-light
                          input-icon
                        "
                        dense
                        flat
                        filled
                        solo
                      ></v-select>
                    </v-col>
                    <v-col
                      cols="12"
                      md="2"
                      id="filtrar"
                      class="d-flex align-center justify-end filter-actions"
                    >
                      <v-btn
                        text
                        height="39"
                        class="font-weight-bold text-none px-3"
                        :disabled="loading || !possuiFiltros"
                        @click="limparFiltros"
                      >
                        {{ $t("Limpar") }}
                      </v-btn>
                      <v-btn
                        @click="filtrar"
                        :loading="loading"
                        :disabled="periodoInvalido"
                        id="btn--filtrar"
                        :ripple="false"
                        class="
                          ma-1
                          font-weight-bold
                          text-none
                          ms-auto
                          btn-primary
                          bg-gradient-primary
                          py-3
                          px-4
                          ms-2
                        "
                        height="39"
                      >
                        <v-icon left dark> ni-zoom-split-in </v-icon>
                        {{ $t("Filtrar") }}
                      </v-btn>
                    </v-col>
                  </v-row>
                  <v-alert
                    v-if="periodoInvalido"
                    dense
                    text
                    type="warning"
                    class="mt-2 mb-0"
                  >
                    {{ $t("Data_final_menor_data_inicial") }}
                  </v-alert>
                </div>

                <v-card-text class="px-0 py-0">
                  <v-data-table
                    id="headers"
                    :headers="headers"
                    :items="recursos"
                    :search="search"
                    :items-per-page="pageSize"
                    :show-expand="true"
                    hide-default-footer
                    disable-pagination
                    deletable-chips
                    :single-expand="true"
                    class="elevation-1"
                    :loading="loading"
                    :loading-text="$t('Carregando')"
                    :no-data-text="$t('Nenhum_resultado_encontrado')"
                    item-class="ATIVO"
                    @item-expanded="handleItemExpanded"
                  >
                    <template v-slot:[`item.nsr`]="{ item }">
                      <span class="font-weight-bold"
                        >#{{ item.nsr || item.id }}</span
                      >
                    </template>
                    <template v-slot:expanded-item="{ item, headers }">
                      <td :colspan="headers.length" class="expanded-cell">
                        <div
                          v-if="item.carregandoDetalhes"
                          class="d-flex align-center justify-center pa-6"
                          role="status"
                        >
                          <v-progress-circular
                            indeterminate
                            color="primary"
                            size="24"
                            width="3"
                          />
                          <span class="ms-3 text-body-2">
                            {{ $t("Carregando") }}
                          </span>
                        </div>
                        <v-alert
                          v-else-if="item.erroDetalhes"
                          text
                          type="warning"
                          class="ma-4"
                        >
                          {{ $t("Tente_novamente") }}
                          <v-btn
                            text
                            small
                            class="ms-2 text-none"
                            @click="recarregarDetalhes(item)"
                          >
                            {{ $t("Atualizar") }}
                          </v-btn>
                        </v-alert>
                        <conteudo-expansion-orcamento-despesa
                          v-else-if="item.detalhesCarregados"
                          :recurso="item"
                          :loading="loading"
                          @atualizado="requestResources"
                        >
                        </conteudo-expansion-orcamento-despesa>
                      </td>
                    </template>
                    <template v-slot:[`item.valorSolicitado`]="{ item }">
                      <span>{{ item.valorSolicitado | formatoMonetario }}</span>
                    </template>
                    <template v-slot:[`item.valorSaldo`]="{ item }">
                      <span>{{ item.valorSaldo | formatoMonetario }}</span>
                    </template>
                    <template v-slot:[`item.periodoInicio`]="{ item }">
                      <span>{{ item.periodoInicio | dataParaLeitura }}</span>
                    </template>
                    <template v-slot:[`item.periodoEncerramento`]="{ item }">
                      <span>{{
                        item.periodoEncerramento | dataParaLeitura
                      }}</span>
                    </template>
                    <template v-slot:[`item.actions`]="{ item }">
                      <div
                        class="orcamento-listagem-actions"
                        role="group"
                        :aria-label="$t('Acoes')"
                      >
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon
                              v-if="item.statusPedido === 'PENDENTE'"
                              v-can="'ROLE_PedidoOrcamentoDespesa_Approve'"
                              v-bind="attrs"
                              v-on="on"
                              small
                              name="approveBtn"
                              :aria-label="$t('Aprovar')"
                              color="#67748e"
                              class="btn-ls me-0.90 my-1 rounded-sm ma-1"
                              icon
                              elevation="0"
                              :ripple="false"
                              @click="aprovar(item)"
                            >
                              mdi-check-circle-outline
                            </v-icon>
                          </template>
                          <span>{{ $t("Aprovar") }}</span>
                        </v-tooltip>

                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon
                              v-if="item.statusPedido === 'ENCERRADO'"
                              v-can="'ROLE_PedidoOrcamentoDespesa_Completed'"
                              v-bind="attrs"
                              v-on="on"
                              small
                              name="completeBtn"
                              :aria-label="$t('Concluir')"
                              color="#67748e"
                              class="btn-ls me-0.90 my-1 rounded-sm ma-1"
                              icon
                              elevation="0"
                              :ripple="false"
                              @click="concluir(item)"
                            >
                              mdi-flag-checkered
                            </v-icon>
                          </template>
                          <span>{{ $t("Concluir") }}</span>
                        </v-tooltip>

                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon
                              v-can="'ROLE_PedidoOrcamentoDespesa_Delete'"
                              v-bind="attrs"
                              v-on="on"
                              small
                              name="deleteBtn"
                              :aria-label="$t('Cancelar')"
                              color="#67748e"
                              class="btn-ls me-0.90 my-1 rounded-sm ma-1"
                              icon
                              elevation="0"
                              :ripple="false"
                              @click="confirmaDelete(item)"
                            >
                              mdi-close-circle-outline
                            </v-icon>
                          </template>
                          <span>{{ $t("Cancelar") }}</span>
                        </v-tooltip>

                        <span
                          v-if="loadingPdfId === item.id"
                          class="orcamento-action-loading ma-1"
                          role="status"
                          :aria-label="$t('Gerar_PDF')"
                        >
                          <v-progress-circular
                            indeterminate
                            color="#67748e"
                            size="18"
                            width="2"
                          />
                        </span>
                        <v-tooltip v-else bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon
                              v-can="'ROLE_PedidoOrcamentoDespesa_List'"
                              v-bind="attrs"
                              v-on="on"
                              small
                              name="pdfBtn"
                              :aria-label="$t('Gerar_PDF')"
                              color="#67748e"
                              class="btn-ls me-0.90 my-1 rounded-sm ma-1"
                              icon
                              elevation="0"
                              :ripple="false"
                              @click.stop="gerarPdf(item)"
                            >
                              mdi-file-pdf-box
                            </v-icon>
                          </template>
                          <span>{{ $t("Gerar_PDF") }}</span>
                        </v-tooltip>

                        <span
                          v-if="loadingMessageId === item.id"
                          class="orcamento-action-loading ma-1"
                          role="status"
                          :aria-label="$t('Carregando')"
                        >
                          <v-progress-circular
                            indeterminate
                            color="#67748e"
                            size="18"
                            width="2"
                          />
                        </span>
                        <v-tooltip v-else bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon
                              v-bind="attrs"
                              v-on="on"
                              small
                              name="messageBtn"
                              :aria-label="$t('Mensagens')"
                              color="#67748e"
                              class="btn-ls me-0.90 my-1 rounded-sm ma-1"
                              icon
                              elevation="0"
                              :ripple="false"
                              @click="showMessages(item)"
                            >
                              mdi-message-text-outline
                            </v-icon>
                          </template>
                          <span>{{ $t("Mensagens") }}</span>
                        </v-tooltip>
                      </div>
                    </template>

                    <template
                      v-slot:[`item.orcamentodespesaPeriodoApuracao.inicioPeriodo`]="{
                        item,
                      }"
                    >
                      {{
                        item.orcamentodespesaPeriodoApuracao.inicioPeriodo
                          | dataParaLeitura
                      }}
                    </template>
                    <template
                      v-slot:[`item.orcamentodespesaPeriodoApuracao.finalPeriodo`]="{
                        item,
                      }"
                    >
                      {{
                        item.orcamentodespesaPeriodoApuracao.finalPeriodo
                          | dataParaLeitura
                      }}
                    </template>
                    <template v-slot:[`item.inconsistencia`]="{ item }">
                      {{ $t(item.inconsistencia ? "sim" : "nao") }}
                    </template>
                    <template v-slot:[`item.valorTotal`]="{ item }">
                      {{ item.valorTotal | formatoMonetario }}
                    </template>
                    <template v-slot:[`item.outrosTotal`]="{ item }">
                      {{ item.outrosTotal | formatoMonetario }}
                    </template>

                    <template v-slot:[`item.valorUtilizado`]="{ item }">
                      {{ item.valorUtilizado | formatoMonetario }}
                    </template>
                    <template v-slot:[`item.vrTotal`]="{ item }">
                      {{ item.vrTotal | formatoMonetario }}
                    </template>
                    <template v-slot:[`item.vtTotal`]="{ item }">
                      {{ item.vtTotal | formatoMonetario }}
                    </template>
                    <template v-slot:[`item.statusPedido`]="{ item }">
                      <div class="d-flex flex-column align-start">
                        <v-chip
                          small
                          label
                          :color="statusConfig(item.statusPedido).color"
                          text-color="white"
                          class="orcamento-status-chip"
                        >
                          <v-icon left x-small>
                            {{ statusConfig(item.statusPedido).icon }}
                          </v-icon>
                          {{ $t(item.statusPedido) }}
                        </v-chip>
                        <v-chip
                          v-if="item.integracaoTotvsStatus"
                          x-small
                          outlined
                          :color="
                            corStatusIntegracaoTotvs(item.integracaoTotvsStatus)
                          "
                          class="mt-1 integracao-totvs-chip"
                          tabindex="0"
                          title="Ver detalhes da integração com a TOTVS"
                          @click.stop="abrirStatusIntegracaoTotvs(item)"
                          @keydown.enter.prevent="
                            abrirStatusIntegracaoTotvs(item)
                          "
                          @keydown.space.prevent="
                            abrirStatusIntegracaoTotvs(item)
                          "
                        >
                          TOTVS:
                          {{
                            rotuloStatusIntegracaoTotvs(
                              item.integracaoTotvsStatus
                            )
                          }}
                        </v-chip>
                      </div>
                    </template>
                  </v-data-table>
                </v-card-text>
                <v-card-actions class="card-padding">
                  <v-row class="align-center">
                    <v-col
                      cols="12"
                      md="7"
                      lg="6"
                      class="d-flex flex-wrap align-center"
                    >
                      <span class="text-body me-3"
                        >{{ $t("Itens_por_pagina") }}:</span
                      >
                      <v-select
                        v-model="pageSize"
                        :items="pageSizes"
                        @change="handlePageSizeChange"
                        :disabled="loading"
                        hide-details
                        class="
                          input-style
                          font-size-input
                          text-light-input
                          placeholder-light
                          input-icon
                          page-size-select
                        "
                        dense
                        flat
                        filled
                        solo
                      ></v-select>
                      <span class="text-caption text-secondary ms-4">
                        {{ $t("Resultado") }}: {{ totalItems }}
                      </span>
                    </v-col>
                    <v-col
                      cols="12"
                      md="5"
                      lg="6"
                      class="ml-auto d-flex justify-end"
                    >
                      <v-pagination
                        prev-icon="fa fa-angle-left"
                        next-icon="fa fa-angle-right"
                        class="pagination"
                        color="#516a78ee"
                        v-model="page"
                        :length="Math.max(totalPages, 1)"
                        @input="handlePageChange"
                        :disabled="loading || totalPages <= 1"
                        circle
                      ></v-pagination>
                    </v-col>
                  </v-row>
                </v-card-actions>
              </v-card>
            </div>
          </template>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<style scoped>
.integracao-totvs-card {
  overflow: hidden;
  border-radius: 14px;
}

.integracao-totvs-header {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 22px 24px 14px;
}

.integracao-totvs-header__icon,
.integracao-totvs-step__marker {
  display: inline-flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  color: white;
  background: #5e72e4;
  border-radius: 50%;
}

.integracao-totvs-header__icon {
  width: 46px;
  height: 46px;
}

.integracao-totvs-header__icon--success,
.integracao-totvs-step__marker.is-success {
  background: #2d9d78;
}

.integracao-totvs-header__icon--warning,
.integracao-totvs-step__marker.is-warning {
  background: #d97706;
}

.integracao-totvs-header__eyebrow {
  color: #67748e;
  font-size: 0.8rem;
  font-weight: 700;
}

.integracao-totvs-header__title {
  color: #344767;
  font-size: 1.2rem;
  font-weight: 800;
  line-height: 1.35;
}

.integracao-totvs-step {
  display: flex;
  align-items: flex-start;
  gap: 14px;
  padding: 12px 2px;
}

.integracao-totvs-step__marker {
  width: 32px;
  height: 32px;
}

.integracao-totvs-step__title {
  color: #344767;
  font-size: 0.95rem;
  font-weight: 800;
  line-height: 1.4;
}

.integracao-totvs-step__text {
  color: #67748e;
  font-size: 0.875rem;
  line-height: 1.55;
}

.integracao-totvs-connector {
  width: 2px;
  height: 18px;
  margin-left: 17px;
  background: #dce1e8;
}

.integracao-totvs-chip {
  cursor: pointer;
}

.orcamento-status-chip {
  border-radius: 7px !important;
  font-weight: 700;
  letter-spacing: 0.01em;
}

.orcamento-listagem-actions {
  display: inline-flex;
  align-items: center;
  flex-wrap: wrap;
}

.orcamento-action-loading {
  display: inline-flex;
  width: 30px;
  height: 30px;
  align-items: center;
  justify-content: center;
  border: 1px solid #e4e7ec;
  border-radius: 7px;
  background: #f8fafc;
}

.mensagem-item {
  padding: 12px 14px;
  margin-bottom: 8px;
  border: 1px solid rgba(103, 116, 142, 0.14);
  border-radius: 10px;
}

.naoSolicitante {
  margin-left: 32px;
  background-color: #f7f7f7;
}

.solicitante {
  margin-right: 32px;
  background-color: #e8f5e9;
}

.modal-content {
  max-height: 420px;
  overflow-y: auto;
}

.page-size-select {
  flex: 0 0 88px;
  max-width: 88px;
}

.expanded-cell {
  padding: 0 !important;
  background-color: #f8f9fa;
}

@media (max-width: 959px) {
  .filter-actions {
    justify-content: flex-start !important;
  }
}

@media (max-width: 599px) {
  .integracao-totvs-header {
    padding: 18px 18px 12px;
  }

  .integracao-totvs-card .v-card__actions {
    align-items: stretch;
    flex-direction: column;
    gap: 8px;
  }

  .integracao-totvs-card .v-card__actions .v-btn {
    width: 100%;
    margin: 0 !important;
  }

  .integracao-totvs-card .v-card__actions .spacer {
    display: none;
  }
}
</style>

<script>
import standaloneCrudKeyboardShortcuts from "@/mixins/standaloneCrudKeyboardShortcuts";
import DataService from "@/services/ComumDataService";
import ConteudoExpansionOrcamentoDespesa from "./ConteudoExpansionOrcamentoDespesa.vue";
export default {
  mixins: [standaloneCrudKeyboardShortcuts],
  name: "ListagemOrcamentoDespesaApuracao",
  components: {
    ConteudoExpansionOrcamentoDespesa,
  },
  data() {
    return {
      opcaoApuracaoCsv: null,
      modalExportar: false,
      modalMensagens: false,
      modalNovaMensagem: false,
      modalIntegracaoTotvs: false,
      integracaoTotvsDemoraTimer: null,
      integracaoTotvsDemorando: false,
      integracaoTotvsRequisicaoAtiva: false,
      reprocessandoIntegracaoTotvs: false,
      integracaoTotvs: {
        necessaria: false,
        pedidoId: null,
        pedidoNsr: null,
        tipo: null,
        status: null,
        mensagem: "",
        mensagemCajupe: "",
      },
      notificacaoIntegracaoTotvs: {
        visivel: false,
        cor: "success",
        mensagem: "",
      },
      maxCaracteres: 255,
      novaMensagem: "",
      recursos: [],
      errors: [],
      recurso: {
        mensagens: [{ responsavel: {}, data: "", texto: "" }],
        solicitante: { nome: "" },
      },
      filtros: {
        inicio: "",
        encerramento: "",
      },

      loading: false,
      loadingPdfId: null,
      loadingMessageId: null,
      listagemRequestId: 0,
      detalhesPromises: {},
      deletado: false,
      confirmarDelete: false,
      nome: "",
      statusPedido: null,

      headers: [
        {
          text: "NSR",
          value: "nsr",
          sortable: "true",
        },
        {
          text: this.$t("Solicitante"),
          value: "solicitante.nome",
          sortable: "true",
        },
        {
          text: this.$t("Status"),
          value: "statusPedido",
          sortable: "true",
        },
        {
          text: this.$t("Data_inicio"),
          value: "periodoInicio",
          sortable: "true",
        },
        {
          text: this.$t("Data_fim"),
          value: "periodoEncerramento",
          sortable: "true",
        },
        {
          text: this.$t("Valor_solicitado"),
          value: "valorSolicitado",
          sortable: "true",
        },
        {
          text: this.$t("Valor_utilizado"),
          value: "valorUtilizado",
          sortable: "true",
        },
        {
          text: this.$t("Saldo"),
          value: "valorSaldo",
          sortable: "true",
        },
        {
          text: this.$t("Acoes"),
          value: "actions",
          sortable: "true",
        },
      ],

      headersApuracaoDia: [
        {
          text: this.$t("Data"),
          value: "data",
          sortable: "true",
        },
      ],

      //Paginação
      searchApuracaoDia: "",
      search: "",
      searchApuracao: "",

      page: 1,
      totalPages: 0,
      totalItems: 0,
      pageSize: 8,
      pageSizes: [8, 16, 24],
      orderBy: "nsr",

      direction: "DESC",
      directions: [
        { text: this.$t("Crescente"), value: "ASC" },
        { text: this.$t("Decrescente"), value: "DESC" },
      ],
    };
  },

  computed: {
    integracaoTotvsEmAndamento() {
      return ["PENDENTE", "PROCESSANDO"].includes(this.integracaoTotvs.status);
    },
    integracaoTotvsFalhou() {
      return this.integracaoTotvs.status === "FALHA";
    },
    podeReprocessarIntegracaoTotvs() {
      return (
        !this.integracaoTotvsRequisicaoAtiva &&
        ["PENDENTE", "FALHA"].includes(this.integracaoTotvs.status)
      );
    },
    corIntegracaoTotvs() {
      if (this.integracaoTotvs.status === "SUCESSO") return "success";
      if (this.integracaoTotvs.status === "FALHA") return "warning";
      return "primary";
    },
    iconeIntegracaoTotvs() {
      if (this.integracaoTotvs.status === "SUCESSO") return "mdi-check";
      if (this.integracaoTotvs.status === "FALHA") return "mdi-alert-outline";
      return "mdi-sync";
    },
    tituloIntegracaoTotvs() {
      if (this.integracaoTotvs.status === "SUCESSO") {
        return "Integração concluída";
      }
      if (this.integracaoTotvs.status === "FALHA") {
        return "A integração com a TOTVS não foi concluída";
      }
      if (this.integracaoTotvsDemorando) {
        return "A TOTVS está demorando para responder";
      }
      return "Aguardando resposta da TOTVS";
    },
    rotuloIntegracaoTotvs() {
      const rotulos = {
        PENDENTE: "Aguardando",
        PROCESSANDO: "Integrando",
        SUCESSO: "Concluída",
        FALHA: "Falha na TOTVS",
      };
      return rotulos[this.integracaoTotvs.status] || "Aguardando";
    },
    mensagemIntegracaoTotvs() {
      if (this.integracaoTotvsEmAndamento && this.integracaoTotvsDemorando) {
        return "A TOTVS está demorando mais que o esperado para responder. A solicitação já está salva no Cajupe; estamos aguardando somente o retorno da TOTVS.";
      }
      return (
        this.integracaoTotvs.mensagem ||
        "Agora estamos integrando com a TOTVS. Aguardando resposta..."
      );
    },
    possuiFiltros() {
      return Boolean(
        String(this.nome || "").trim() ||
          this.statusPedido ||
          this.filtros.inicio ||
          this.filtros.encerramento
      );
    },
    periodoInvalido() {
      return Boolean(
        this.filtros.inicio &&
          this.filtros.encerramento &&
          this.filtros.inicio > this.filtros.encerramento
      );
    },
  },

  mounted() {
    this.sugestaoVencimento();
    this.filtrar();
    //this.getFuncionarios();
  },

  beforeDestroy() {
    this.limparAvisoDemoraTotvs();
  },

  watch: {
    // search: function () {
    //   this.handleSearchChange();
    // },

    submited: function (newValue) {
      if (newValue) {
        this.requestResources();
      }
    },

    // matricula: function () {
    //   //  if (this.matricula.length == 0 || this.matricula.length > 0) {
    //   this.requestResources();
    //   //}
    // },
    // nome: function () {
    //   if (this.nome.length == 0 || this.nome.length > 3) {
    //     this.requestResources();
    //   }
    // },
  },

  methods: {
    sugestaoVencimento() {
      const now = new Date();
      this.filtros.inicio = this.utils_dateObj_to_ymd(
        new Date(now.getFullYear(), now.getMonth(), 1)
      );
      this.filtros.encerramento = this.utils_dateObj_to_ymd(
        new Date(now.getFullYear(), now.getMonth() + 1, 0)
      );
    },
    utils_dateObj_to_ymd(payload = null) {
      let today;
      if (payload) {
        today = new Date(payload);
      } else {
        today = new Date();
      }
      const date =
        today.getFullYear() +
        "-" +
        (today.getMonth() + 1).toString().padStart(2, "0") +
        "-" +
        today.getDate().toString().padStart(2, "0");

      return date;
    },
    filtrar() {
      if (this.periodoInvalido) {
        return;
      }
      this.page = 1;
      this.requestResources();
    },
    limparFiltros() {
      this.nome = "";
      this.statusPedido = null;
      this.filtros.inicio = "";
      this.filtros.encerramento = "";
      this.filtrar();
    },
    getFilterPayload() {
      return {
        status: this.statusPedido,
        solicitante: String(this.nome || "").trim(),
        dataInicio: this.filtros.inicio || null,
        dataFim: this.filtros.encerramento || null,
      };
    },
    download(content, fileName, mimeType) {
      var a = document.createElement("a");
      mimeType = mimeType || "application/octet-stream";

      if (navigator.msSaveBlob) {
        // IE10
        navigator.msSaveBlob(
          new Blob([content], {
            type: mimeType,
          }),
          fileName
        );
      } else if (URL && "download" in a) {
        //html5 A[download]
        a.href = URL.createObjectURL(
          new Blob([content], {
            type: mimeType,
          })
        );
        a.setAttribute("download", fileName);
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      } else {
        location.href =
          "data:application/octet-stream," + encodeURIComponent(content); // only this mime type is supported
      }
    },

    async gerarPdf(recurso) {
      if (!recurso?.id || this.loadingPdfId === recurso.id) {
        return;
      }

      this.loadingPdfId = recurso.id;
      try {
        const { data } = await DataService.get(
          `pedidoOrcamentoDespesas/${recurso.id}/print`,
          { responseType: "blob" }
        );
        this.abrirPdf(
          data,
          `orcamento-despesa-${recurso.nsr || recurso.id}.pdf`
        );
      } catch (error) {
        console.log("Erro ao gerar PDF do orçamento de despesa", error);
        this.$swal.fire(
          this.$t("Erro"),
          this.$t("Tente_novamente_mais_tarde"),
          "error"
        );
      } finally {
        if (this.loadingPdfId === recurso.id) {
          this.loadingPdfId = null;
        }
      }
    },

    abrirPdf(content, fileName) {
      const blob =
        content instanceof Blob
          ? content
          : new Blob([content], { type: "application/pdf" });
      const url = window.URL.createObjectURL(blob);
      const opened = window.open(url, "_blank");
      if (!opened) {
        const link = document.createElement("a");
        link.href = url;
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
      window.setTimeout(() => window.URL.revokeObjectURL(url), 60000);
    },

    retrieveData() {
      this.requestResources();
    },

    requestResources() {
      this.loading = true;
      const requestId = ++this.listagemRequestId;

      DataService.post(
        "pedidoOrcamentoDespesas/filter/page",
        this.getFilterPayload(),
        { params: this.getRequestParams() }
      )
        .then((response) => {
          if (requestId !== this.listagemRequestId) {
            return;
          }

          const data = response.data || {};
          const totalPages = Number(data.totalPages || 0);
          if (totalPages > 0 && this.page > totalPages) {
            this.page = totalPages;
            this.requestResources();
            return;
          }

          const recursosAtuais = new Map(
            this.recursos.map((recurso) => [recurso.id, recurso])
          );
          this.recursos = Array.isArray(data.content)
            ? data.content.map((item) => {
                const recursoAtual = recursosAtuais.get(item.id);
                if (recursoAtual) {
                  Object.keys(item).forEach((key) => {
                    this.$set(recursoAtual, key, item[key]);
                  });
                  return recursoAtual;
                }
                return {
                  ...item,
                  detalhesCarregados: false,
                  carregandoDetalhes: false,
                  erroDetalhes: false,
                };
              })
            : [];
          this.totalPages = totalPages;
          this.totalItems = Number(data.totalElements || 0);
          this.pageSize = Number(data.size || this.pageSize);
        })
        .catch((error) => {
          if (requestId !== this.listagemRequestId) {
            return;
          }
          console.log("Erro ao filtrar orçamentos de despesa", error);
          this.recursos = [];
          this.totalPages = 0;
          this.totalItems = 0;
          this.$swal.fire(
            this.$t("Erro"),
            this.$t("Tente_novamente_mais_tarde"),
            "error"
          );
        })
        .finally(() => {
          if (requestId === this.listagemRequestId) {
            this.loading = false;
          }
        });
    },

    getAll() {
      DataService.get("orcamentodespesaApuracao/period", {
        params: {},
      }).then((response) => {
        this.recursos = response.data;
      });
    },

    downloadPdf(string) {
      console.log("metodo certo");
      window.open("data:application/pdf," + encodeURI(string));
    },

    exportaCsv() {
      this.loading = true;
      DataService.put(
        "pedidoOrcamentoDespesas/exportCsv",
        this.getFilterPayload(),
        {
          responseType: "blob",
        }
      )
        .then((res) => {
          this.download(res.data, "orcamentodespesa.csv", "CSV/plain");
          this.loading = false;
        })
        .catch((err) => {
          console.log("Erro ao exportar orçamentos de despesa", err);
          this.loading = false;
        });
    },

    /* Paginação */
    getRequestParams() {
      let params = {};
      let page = this.page;
      let pageSize = this.pageSize;
      let orderBy = this.orderBy;
      let direction = this.direction;

      if (page) {
        params["page"] = page - 1;
      }

      if (pageSize) {
        params["linesPerPage"] = pageSize;
      }

      if (orderBy) {
        params["orderBy"] = orderBy;
      }

      if (direction) {
        params["direction"] = direction;
      }
      return params;
    },

    handlePageChange(value) {
      this.page = value;
      this.retrieveData();
    },

    handlePageSizeChange(size) {
      this.pageSize = size;
      this.page = 1;
      this.retrieveData();
    },

    handleOrderByChange(value) {
      this.orderBy = value;
      this.page = 1;
      this.retrieveData();
    },

    handleDirectionChange(value) {
      (this.direction = value), this.retrieveData();
    },

    // getAll() {
    //   this.loading = true;
    //   console.log("getAll", this.search);
    //   DataService.get("orcamentodespesaApuracao/period/funcionario", {
    //     params: {
    //       inicio: this.periodoSelecionado.inicioPeriodo,
    //       final: this.periodoSelecionado.finalPeriodo,
    //       matricula: this.search.matricula,
    //     },
    //   }).then((response) => {
    //     this.recursos = response.data;
    //     this.loading = false;
    //   });
    // },

    confirmaDelete(recurso) {
      this.objetoAtual = recurso;
      this.confirmarDelete = true;
    },

    statusConfig(status) {
      const configs = {
        PENDENTE: {
          color: "#B45309",
          icon: "mdi-clock-outline",
        },
        APROVADO: {
          color: "#15803D",
          icon: "mdi-check-circle-outline",
        },
        PROCESSAMENTO: {
          color: "#2563EB",
          icon: "mdi-progress-clock",
        },
        TRANSFERENCIARECURSO: {
          color: "#7C3AED",
          icon: "mdi-swap-horizontal",
        },
        ENCERRADO: {
          color: "#4338CA",
          icon: "mdi-lock-outline",
        },
        CONCLUIDO: {
          color: "#0F766E",
          icon: "mdi-check-all",
        },
        CANCELADO: {
          color: "#B91C1C",
          icon: "mdi-close-circle-outline",
        },
      };
      return (
        configs[status] || {
          color: "#64748B",
          icon: "mdi-help-circle-outline",
        }
      );
    },

    corStatusIntegracaoTotvs(status) {
      const cores = {
        PENDENTE: "primary",
        PROCESSANDO: "primary",
        SUCESSO: "success",
        FALHA: "warning",
      };
      return cores[status] || "grey";
    },

    rotuloStatusIntegracaoTotvs(status) {
      const rotulos = {
        PENDENTE: "Aguardando",
        PROCESSANDO: "Integrando",
        SUCESSO: "Concluída",
        FALHA: "Falha na TOTVS",
      };
      return rotulos[status] || status;
    },

    abrirStatusIntegracaoTotvs(recurso) {
      if (this.integracaoTotvsRequisicaoAtiva) {
        this.modalIntegracaoTotvs = true;
        return;
      }
      this.limparAvisoDemoraTotvs();
      this.integracaoTotvs = {
        necessaria: true,
        pedidoId: recurso.id,
        pedidoNsr: recurso.nsr || recurso.id,
        tipo: recurso.integracaoTotvsTipo,
        status: recurso.integracaoTotvsStatus,
        mensagem: recurso.integracaoTotvsMensagem,
        atualizacao: recurso.integracaoTotvsAtualizacao,
        tentativas: recurso.integracaoTotvsTentativas,
        mensagemCajupe: "A operação no Cajupe já está concluída.",
      };
      this.modalIntegracaoTotvs = true;
    },

    handleItemExpanded({ item, value }) {
      if (value) {
        this.carregarDetalhes(item).catch(() => {});
      }
    },

    recarregarDetalhes(recurso) {
      this.carregarDetalhes(recurso).catch(() => {});
    },

    carregarDetalhes(recurso) {
      if (recurso.detalhesCarregados) {
        return Promise.resolve(recurso);
      }
      if (this.detalhesPromises[recurso.id]) {
        return this.detalhesPromises[recurso.id];
      }

      this.$set(recurso, "carregandoDetalhes", true);
      this.$set(recurso, "erroDetalhes", false);

      const promise = DataService.get("pedidoOrcamentoDespesas/" + recurso.id)
        .then((response) => {
          Object.keys(response.data || {}).forEach((key) => {
            this.$set(recurso, key, response.data[key]);
          });
          this.$set(recurso, "detalhesCarregados", true);
          return recurso;
        })
        .catch((error) => {
          this.$set(recurso, "erroDetalhes", true);
          throw error;
        })
        .finally(() => {
          this.$set(recurso, "carregandoDetalhes", false);
          this.$delete(this.detalhesPromises, recurso.id);
        });

      this.$set(this.detalhesPromises, recurso.id, promise);
      return promise;
    },

    showMessages(recurso) {
      this.loadingMessageId = recurso.id;
      this.carregarDetalhes(recurso)
        .then((recursoCompleto) => {
          this.recurso = recursoCompleto;
          this.modalMensagens = true;
        })
        .catch(() => {
          this.$swal.fire(
            this.$t("Erro"),
            this.$t("Tente_novamente_mais_tarde"),
            "error"
          );
        })
        .finally(() => {
          this.loadingMessageId = null;
        });
    },

    deleteRecurso() {
      this.loading = true;
      DataService.delete("pedidoOrcamentoDespesas/" + this.objetoAtual.id)
        .then(() => {
          this.loading = false;
          this.confirmarDelete = false;
          this.deletado = true;
          this.retrieveData();
        })
        .catch((error) => {
          this.loading = false;
          this.confirmarDelete = false;
          window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
          this.erros = error.response?.data?.errors || [];
          this.$swal.fire(
            this.$t("Erro"),
            this.$t("Nao_foi_possivel_excluir_o_registro"),
            "error"
          );
        });
    },

    aprovar(recurso) {
      if (this.integracaoTotvsRequisicaoAtiva) {
        this.modalIntegracaoTotvs = true;
        return;
      }
      this.loading = true;

      DataService.put("pedidoOrcamentoDespesas/approve", {
        idOrigem: recurso.id,
      })
        .then((response) => {
          this.loading = false;
          this.retrieveData();
          this.tratarOperacaoComIntegracao(
            response,
            "A solicitação foi aprovada no Cajupe."
          );
        })
        .catch((error) => {
          this.loading = false;
          this.confirmarDelete = false;
          window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
          this.erros = error.response?.data?.errors || [];
          this.$swal.fire(
            this.$t("Erro"),
            "Não foi possível aprovar a solicitação no Cajupe.",
            "error"
          );
        });
    },

    concluir(recurso) {
      if (this.integracaoTotvsRequisicaoAtiva) {
        this.modalIntegracaoTotvs = true;
        return;
      }
      this.loading = true;

      DataService.put("pedidoOrcamentoDespesas/completed/" + recurso.id, {})
        .then((response) => {
          this.loading = false;
          this.retrieveData();
          this.tratarOperacaoComIntegracao(
            response,
            "A solicitação foi concluída no Cajupe."
          );
        })
        .catch((error) => {
          this.loading = false;
          this.confirmarDelete = false;
          window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
          this.erros = error.response?.data?.errors || [];
          this.$swal.fire(
            this.$t("Erro"),
            "Não foi possível concluir a solicitação no Cajupe.",
            "error"
          );
        });
    },
    tratarOperacaoComIntegracao(response, mensagemPadrao) {
      const operacao = response?.data || {};
      const integracao = operacao.integracaoTotvs;
      if (!integracao?.necessaria) {
        this.$swal.fire(
          this.$t("Sucesso"),
          operacao.mensagem || mensagemPadrao,
          "success"
        );
        return;
      }

      this.iniciarIntegracaoTotvsSincrona(
        integracao,
        operacao.mensagem || mensagemPadrao
      );
    },
    iniciarIntegracaoTotvsSincrona(
      integracao,
      mensagemCajupe,
      reprocessamento = false
    ) {
      this.limparAvisoDemoraTotvs();
      this.integracaoTotvs = {
        ...this.integracaoTotvs,
        ...integracao,
        status: "PROCESSANDO",
        mensagem:
          "Agora estamos integrando com a TOTVS. Aguardando resposta...",
        mensagemCajupe,
      };
      this.integracaoTotvsRequisicaoAtiva = true;
      this.modalIntegracaoTotvs = true;
      const { pedidoId, tipo } = this.integracaoTotvs;
      const acao = reprocessamento ? "reprocessar" : "processar";
      this.integracaoTotvsDemoraTimer = window.setTimeout(() => {
        this.integracaoTotvsDemorando = true;
      }, 8000);

      return DataService.post(
        `pedidoOrcamentoDespesas/integracao/totvs/${pedidoId}/${tipo}/${acao}`
      )
        .then((response) => {
          this.integracaoTotvs = {
            ...this.integracaoTotvs,
            ...(response.data || {}),
          };
          this.retrieveData();
          if (!this.modalIntegracaoTotvs) {
            this.notificarResultadoIntegracaoTotvs();
          }
        })
        .catch((error) => {
          this.integracaoTotvs = {
            ...this.integracaoTotvs,
            status: "FALHA",
            mensagem:
              error.response?.data?.message ||
              "Não foi possível receber o retorno da integração. A operação no Cajupe permanece salva; consulte o status da TOTVS antes de tentar novamente.",
          };
          this.retrieveData();
          if (!this.modalIntegracaoTotvs) {
            this.notificarResultadoIntegracaoTotvs();
          }
        })
        .finally(() => {
          this.limparAvisoDemoraTotvs();
          this.integracaoTotvsRequisicaoAtiva = false;
          this.reprocessandoIntegracaoTotvs = false;
        });
    },
    limparAvisoDemoraTotvs() {
      window.clearTimeout(this.integracaoTotvsDemoraTimer);
      this.integracaoTotvsDemoraTimer = null;
      this.integracaoTotvsDemorando = false;
    },
    fecharIntegracaoTotvs() {
      this.modalIntegracaoTotvs = false;
    },
    abrirIntegracaoTotvs() {
      this.notificacaoIntegracaoTotvs.visivel = false;
      this.modalIntegracaoTotvs = true;
    },
    notificarResultadoIntegracaoTotvs() {
      const sucesso = this.integracaoTotvs.status === "SUCESSO";
      this.notificacaoIntegracaoTotvs = {
        visivel: true,
        cor: sucesso ? "success" : "warning",
        mensagem: sucesso
          ? "Integração com a TOTVS concluída."
          : "A TOTVS não concluiu a integração. A operação no Cajupe está salva.",
      };
    },
    reprocessarIntegracaoTotvs() {
      const { pedidoId, tipo } = this.integracaoTotvs;
      if (!pedidoId || !tipo) return;

      this.reprocessandoIntegracaoTotvs = true;
      this.iniciarIntegracaoTotvsSincrona(
        this.integracaoTotvs,
        this.integracaoTotvs.mensagemCajupe,
        true
      );
    },
    enviarMensagem() {
      this.loading = true;

      DataService.put("pedidoOrcamentoDespesas/message", {
        id: this.recurso.id,
        texto: this.novaMensagem,
      })
        .then(() => {
          this.loading = false;
          this.$swal.fire(
            this.$t("Sucesso"),
            this.$t("Mensagem_enviada"),
            "success"
          );
          this.modalNovaMensagem = false;
          this.modalMensagens = false;
          this.novaMensagem = "";
          this.retrieveData();
        })
        .catch((error) => {
          this.loading = false;
          this.confirmarDelete = false;
          window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
          this.erros = error.response.data.errors;
          this.$swal.fire(
            this.$t("Erro"),
            this.$t("Tente_novamente_mais_tarde"),
            "error"
          );
          this.modalNovaMensagem = false;
        });
    },
  },
};
</script>

<style>
.ATIVO {
  color: #67748e;
}
</style>
